var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect0, _rect1, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySectionSitting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 96,
    viewBox: "0 0 98 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75586,
    y: 59.813,
    width: 45.8318,
    height: 30.5759,
    rx: 2.39252,
    fill: "#A7A3CD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 59.813,
    width: 45.8318,
    height: 30.5759,
    rx: 2.39252,
    fill: "#CECDE3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.19531,
    y: 79.0244,
    width: 16.3902,
    height: 1.17073,
    rx: 0.585366,
    fill: "#817DB8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.19531,
    y: 74.3413,
    width: 28.6829,
    height: 1.17073,
    rx: 0.585366,
    fill: "#817DB8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.19531,
    y: 69.6582,
    width: 28.6829,
    height: 1.17073,
    rx: 0.585366,
    fill: "#817DB8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16992,
    width: 26.6168,
    height: 13.8013,
    rx: 1.75255,
    fill: "#A7A3CD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 26.6168,
    height: 13.8013,
    rx: 1.75255,
    fill: "#CECDE3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26758,
    y: 7.60986,
    width: 7.60976,
    height: 1.17073,
    rx: 0.585366,
    fill: "#817DB8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26758,
    y: 5.26807,
    width: 16.3902,
    height: 1.17073,
    rx: 0.585366,
    fill: "#817DB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5712 62.4736L40.4114 50.9165L37.0469 60.7857L58.3517 70.9447C58.6764 71.0996 58.977 71.3004 59.2443 71.5412L78.7665 89.1221L85.9815 80.7483L80.9347 83.066L64.7898 64.2362C64.1694 63.5126 63.4164 62.9143 62.5712 62.4736Z",
    fill: "#21214B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6499 65.857L21.9998 62.523C18.1061 61.9498 15.5332 58.1719 16.4262 54.3389L23.3276 24.716C24.0067 21.8012 26.6049 19.7388 29.5977 19.7388C32.7351 19.7388 35.4156 22.0002 35.9438 25.0928L40.4124 51.2528L54.7028 60.2419C55.9482 61.0253 56.8612 62.2402 57.2672 63.6544L65.6835 92.9724L70.8797 96.0005H58.8423L47.5707 68.1528C47.0732 66.9237 45.9618 66.0501 44.6499 65.857Z",
    fill: "#21214B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4121 51.2529L54.7025 60.242C55.9479 61.0254 56.8609 62.2404 57.2668 63.6546L59.3709 70.9841V66.9589C59.3709 63.6823 57.5848 60.6664 54.7116 59.0914L40.4121 51.2529Z",
    fill: "#06061A",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3563 29.0103C45.4342 31.1162 43.7245 36.3374 44.2628 39.1785C47.4628 38.0719 46.9918 31.8389 46.3563 29.0103Z",
    fill: "#06061A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8962 32.3321L40.0765 24.0378L41.0485 36.1874L49.1699 39.8737C50.6191 40.5315 52.326 40.1996 53.4231 39.0467L62.6186 29.3836L66.0243 26.3783C66.2869 26.1466 66.3535 25.7636 66.1844 25.4568L65.1233 23.5311L66.1892 21.5729C66.3518 21.2741 66.2671 20.901 65.9913 20.7018C65.6887 20.4831 65.2662 20.5512 65.0475 20.8538L62.5806 24.2686C62.4489 24.4509 62.1707 24.4281 62.0705 24.2268L61.5894 23.2609C61.467 23.0153 61.1838 22.8958 60.9225 22.9795C60.6926 23.0532 60.5365 23.2671 60.5365 23.5086L60.5365 25.2467L60.6644 26.3615C60.6957 26.6342 60.575 26.9022 60.35 27.0595L52.6286 32.4569C51.7949 33.0397 50.6733 32.9885 49.8962 32.3321Z",
    fill: "#CECDE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3555 29.0098L36.4863 20.9351L39.9256 35.9631L44.262 39.178C43.7237 36.3369 45.4334 31.1157 46.3555 29.0098Z",
    fill: "#3B377A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7578 55.7764C30.6924 55.7764 29.683 51.253 43.2531 51.253L39.505 25.9054C39.0975 23.1494 37.1914 20.8486 34.5594 19.9355L32.1857 19.1119C30.5666 18.5502 28.8036 18.5617 27.192 19.1447L22.8617 20.711C21.6413 21.1524 20.7372 22.1951 20.4731 23.4657L13.7578 55.7764Z",
    fill: "#3B377A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1921 19.1445L24.4121 20.1501C25.6458 20.499 28.0158 21.4436 28.9729 22.2809C29.9299 23.1183 31.7005 24.9601 32.1858 25.7576C32.977 24.6175 34.5595 21.8569 34.5595 19.9353L32.1858 19.1118C30.5667 18.55 28.8037 18.5616 27.1921 19.1445Z",
    fill: "#CECDE3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.8663 39.9628H21.0475L25.7204 50.7665L24.5989 53.0095L15.6269 41.4955L15.3652 37.0095L27.8886 25.9814L24.007 38.3894C23.7141 39.3255 22.8471 39.9628 21.8663 39.9628Z",
    fill: "#21214B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9168 37.8696C20.6988 37.2591 15.971 34.9238 14.8047 30.4678C17.5087 31.4148 22.9168 34.221 22.9168 37.8696Z",
    fill: "#06061A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.282 39.2006L20.1105 23.0554C20.5923 22.1742 21.3952 21.5126 22.3523 21.208C23.4885 20.8465 24.7276 21.024 25.7166 21.6899L25.948 21.8457C27.1849 22.6784 27.9266 24.0719 27.9266 25.563V25.6209C27.9266 26.4913 27.6791 27.3438 27.213 28.0789L20.1854 39.1622C19.7292 39.8816 19.7199 40.7974 20.1615 41.526L28.3005 54.9535L25.2724 57.1217L11.9058 43.6247C10.7426 42.4501 10.4889 40.651 11.282 39.2006Z",
    fill: "#CECDE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8047 30.468L20.3106 22.5434C20.9304 21.6513 21.8528 21.0144 22.9066 20.751L24.7112 20.2998L26.543 21.1596L28.0383 23.7017V26.9914L22.9168 37.8699C23.0963 34.6101 17.3094 31.3901 14.8047 30.468Z",
    fill: "#3B377A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.1504 31.103L41.1224 36.8227L42.6924 37.9815C41.8551 37.204 40.6488 33.0719 40.1504 31.103Z",
    fill: "#21214B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4597 9.10154C38.1475 10.8062 37.1731 11.8804 36.5999 12.2043L32.3756 18.2977H28.6746C27.4595 18.2977 25.8204 16.7562 24.1498 15.651C23.3303 15.1089 22.9734 13.9491 23.5506 13.1539C25.4489 10.5382 28.2856 7.01968 29.8709 6.40995C31.8148 5.66229 33.4472 6.27288 34.0204 6.67164C34.8802 6.77132 36.7718 7.39687 37.4597 9.10154Z",
    fill: "#55489E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4218 13.3258L37.9078 12.9519L35.6648 9.21363L35.0105 8.49394C34.834 8.29974 34.5028 8.41066 34.4572 8.66914C34.1786 10.2506 33.422 11.2585 32.9732 11.7183C32.7365 11.2448 31.9489 10.5744 31.291 11.3818C30.633 12.1893 31.3159 12.7401 31.6648 12.9519C30.8798 14.1108 31.8143 16.0174 31.4405 17.2136C31.3907 17.575 30.9994 18.2977 29.833 18.2977C28.3751 18.2977 27.9265 18.2604 27.4779 17.9239L27.0293 19.3818H28.6368H32.2629C34.4312 17.1389 34.3564 17.9239 36.3751 17.2136C37.99 16.6454 37.7458 14.385 37.4218 13.3258Z",
    fill: "#CECDE3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8808 11.5966C35.8808 11.719 35.7815 11.8183 35.6591 11.8183C35.5366 11.8183 35.4374 11.719 35.4374 11.5966C35.4374 11.4741 35.5366 11.3749 35.6591 11.3749C35.7815 11.3749 35.8808 11.4741 35.8808 11.5966Z",
    fill: "#55489E",
    stroke: "#55489E",
    strokeWidth: 0.132571
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3125 11.0356C35.4173 10.9534 35.5445 10.9047 35.6774 10.896C35.8103 10.8872 35.9428 10.9188 36.0575 10.9866",
    fill: "#55489E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3125 11.0356C35.4173 10.9534 35.5445 10.9047 35.6774 10.896C35.8103 10.8872 35.9428 10.9188 36.0575 10.9866",
    stroke: "#55489E",
    strokeWidth: 0.205714,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0048 11.8266C32.07 11.9132 32.0991 12.0074 32.0884 12.0967C32.0777 12.186 32.0276 12.2664 31.9448 12.3272",
    fill: "#55489E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0048 11.8266C32.07 11.9132 32.0991 12.0074 32.0884 12.0967C32.0777 12.186 32.0276 12.2664 31.9448 12.3272",
    stroke: "#A7A3CD",
    strokeWidth: 0.224299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9355 17.5703H34.9916C34.8047 17.6077 34.2813 17.6825 33.6084 18.1311L32.9355 17.5703Z",
    fill: "#A7A3CD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6686 13.9129L36.7597 14.1311C36.5728 14.5049 36.7971 15.4769 36.1616 15.4769C35.5261 15.4769 35.0775 14.7666 35.0027 14.3928C34.9844 14.3011 34.9913 14.2188 35.013 14.147C35.0899 13.8922 35.4077 13.8607 35.6686 13.9129Z",
    fill: "#06061A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8327 12.9727L36.9355 13.6082",
    stroke: "#A7A3CD",
    strokeWidth: 0.224299,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 67.8633,
    y: 7.02832,
    width: 29.3084,
    height: 15.197,
    rx: 2.39252,
    fill: "#A7A3CD"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6914,
    y: 7.02832,
    width: 29.3084,
    height: 15.197,
    rx: 2.39252,
    fill: "#CECDE3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 15.2202,
    width: 8.78049,
    height: 1.17073,
    rx: 0.585366,
    fill: "#817DB8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 12.8784,
    width: 18.7317,
    height: 1.17073,
    rx: 0.585366,
    fill: "#817DB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySectionSitting);
export default __webpack_public_path__ + "static/media/empty-section-sitting.cb3b45a1.svg";
export { ForwardRef as ReactComponent };